import { Col, Row, DatePicker, Button } from "antd";
import React from "react";
import { useSelector } from "react-redux";
import { useForma } from "./useForma";

const { RangePicker } = DatePicker;

export const TablaHeader = () => {
  const { loadingList } = useSelector((state) => state.asistenciasReducer);
  const  { handleChange, isDisabled, submit, handleFilter } = useForma();

  //
  return (
    <>
      <Row justify="end" gutter={15} style={{ marginBottom: 10 }}>
        <Col>
          <RangePicker size="small" onChange={handleChange} />
        </Col>
        <Col>
          <Button onClick={handleFilter} disabled={isDisabled} size="small" type="primary" loading={loadingList}>
            Filtrar
          </Button>
        </Col>
        <Col>
          <Button onClick={submit} disabled={isDisabled} size="small" type="primary">
            Descarga XLS
          </Button>
        </Col>
      </Row>

      <Row gutter={10} style={{ marginBottom: 15 }}>
        <Col span={2} className="tituloTabla">
          ID
        </Col>
        <Col span={2} className="tituloTabla">
          Capturado
        </Col>
        <Col span={2} className="tituloTabla">
          Asignado
        </Col>
        <Col span={2} className="tituloTabla">
          Arribo
        </Col>
        <Col span={2} className="tituloTabla">
          Conclusión
        </Col>
        <Col span={3} className="tituloTabla">
          Titular
        </Col>
        <Col span={3} className="tituloTabla">
          Servicio
        </Col>
        <Col span={1} className="tituloTabla">
          Cita
        </Col>
        <Col span={2} className="tituloTabla">
          Loc/Carr
        </Col>
        <Col span={3} className="tituloTabla">
          Origen
        </Col>
        <Col span={2} className="tituloTabla">
          Cancelación
        </Col>
      </Row>
    </>
  );
};
